import { Directive, ElementRef, Input, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { AbstractControl, NgControl, NgModel } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ValidationService, ValidationState } from '../../core/services/ui/validation.service';

@Directive({
  selector: '[border-validation]'
})
export class ValidationBorderDirective implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private control?: AbstractControl | null;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private ngControl: NgControl,
    private validationService: ValidationService
  ) {}

  ngOnInit(): void {
    this.control = this.ngControl?.control;
    
    if (this.control) {
      this.setupValidationListener();
    } else {
      setTimeout(() => {
        const ngModel = this.ngControl as NgModel;
        if (ngModel && ngModel.control) {
          this.control = ngModel.control;
          this.setupValidationListener();
        }
      }, 0);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setupValidationListener(): void {
    if (!this.control) return;

    this.control.statusChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateValidationMessage();
      });

    this.control.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateValidationMessage();
      });

    setTimeout(() => this.updateValidationMessage(), 0);
  }

  private updateValidationMessage(): void {
    if (!this.control) return;

    this.validationService.removeBorderStyles(this.elementRef, this.renderer);

    const validationState = this.validationService.getValidationState(this.control, this.elementRef);

    if (this.validationService.shouldShowError(validationState)) {
      this.validationService.applyErrorBorder(this.elementRef, this.renderer);
    } else if (this.validationService.shouldApplySuccessBorder(validationState)) {
      this.validationService.applySuccessBorder(this.elementRef, this.renderer);
    }
  }


}